import { type PartnerTier } from "./partnerTiers.ts";

export const partnerTierBackgroundColors: Record<PartnerTier, { light: string; dark: string }> = {
    Standard: {
        light: "radial-gradient(80% 28% at 50% 0%, color-mix(in srgb, var(--hop-rock-300) 20%, transparent) 0%, transparent 100%)",
        dark: "radial-gradient(80% 28% at 50% 0%, color-mix(in srgb, var(--hop-rock-300) 15%, transparent) 0%, transparent 100%)"
    },
    Premier: {
        light: "radial-gradient(80% 28% at 50% 0%, color-mix(in srgb, var(--hop-iris-600) 36%, transparent) 0%, transparent 100%)",
        dark: "radial-gradient(80% 28% at 50% 0%, color-mix(in srgb, var(--hop-iris-600) 50%, transparent) 0%, transparent 100%)"
    },
    Elite: {
        light: "radial-gradient(80% 28% at 50% 0%, color-mix(in srgb, var(--hop-iris-600) 36%, transparent) 0%, transparent 100%)",
        dark: "radial-gradient(80% 28% at 50% 0%, color-mix(in srgb, var(--hop-iris-600) 50%, transparent) 0%, transparent 100%)"
    }
};
